import 'moment-timezone';

import { Injectable } from '@angular/core';
import {
    AppStateFacade,
    Setting,
} from '@app-state';
import { Interval } from '@models';

import * as moment from 'moment';

@Injectable()
export class ChartService {
    constructor(
        private _appState: AppStateFacade,
    ) { }

    public getTransactionsLabelForInterval(interval: Interval) {
        const timezone: string = this._appState.settings.get(Setting.timezone)!;
        const now = moment();
        // Because there are timezones that also have several minutes as offset to UTC (not just hours),
        // tz(timezone) has to be applied after mutating the moment.

        switch (interval) {
            case Interval.Hour:
                return `${
                    now.clone()
                        .subtract(59, 'minutes')
                        .tz(timezone)
                        .format('LT')} - ${
                    now.clone()
                        .tz(timezone)
                        .format('LT')}`;
            case Interval.Day:
                return `${
                    now.clone()
                        .subtract(23, 'hours')
                        .minute(0)
                        .tz(timezone)
                        .format('LLL')} - ${
                    now.clone()
                        .minute(0)
                        .tz(timezone)
                        .format('LLL')}`;
            case Interval.Week:
                return `${
                    now.clone()
                        .startOf('day')
                        .subtract(6, 'days')
                        .tz(timezone)
                        .format('LL')} - ${
                    now.clone()
                        .startOf('day')
                        .tz(timezone)
                        .format('LL')}`;
            case Interval.Month:
                return `${
                    now.clone()
                        .startOf('day')
                        .subtract(29, 'days')
                        .tz(timezone)
                        .format('LL')} - ${
                    now.clone()
                        .startOf('day')
                        .tz(timezone)
                        .format('LL')}`;
            default:
                return '';
        }
    }

    public getLicenseUsageLabelForInterval(interval: Interval) {
        const timezone: string = this._appState.settings.get(Setting.timezone)!;
        const now = moment()
            .startOf('day')
            .tz(timezone);

        switch (interval) {
            case Interval.Week:
                return `${
                    now.clone()
                        .subtract(7, 'days')
                        .format('LL')} - ${
                    now.clone()
                        .subtract(1, 'day')
                        .format('LL')}`;
            case Interval.Month:
                return `${
                    now.clone()
                        .subtract(30, 'days')
                        .format('LL')} - ${
                    now.clone()
                        .subtract(1, 'day')
                        .format('LL')}`;
            case Interval.ThreeMonths:
                return `${
                    now.clone()
                        .subtract(90, 'days')
                        .format('LL')} - ${
                    now.clone()
                        .subtract(1, 'day')
                        .format('LL')}`;
            default:
                throw new Error(`getLicenseUsageLabelForInterval: unknown interval:[${interval}]`);
        }

    }
}
